<template>
    <div class='lock-it-in-summary-container'>
        <Toast :alert_queue='alert_queue'/>   
        <div v-if='loading' class='loading-container'>
            <Loading />
        </div>

        <div class='locked-in-text' v-if='!loading'>
            <NumberFlow :value="cart_totals.total_quantity" prefix="You've locked in "
                :suffix="'/' + lock_it_in_data.quantity + ' bottles'" />
            <LockItInPrice :total='cart_totals.total_with_discounts' :frequency_text='frequency_text' />
            <div class="checkout-button-container">
                <Button v-if='!is_amend' class='checkout-button' text='Checkout' disabled='true ' theme="green" @click='checkout' />
                <Button v-if='is_amend && !is_loading' class='checkout-button' text='Save' disabled='true ' theme='green' @click='save' />
                <div v-show='error_message != ""' class="error-message">
                    {{ error_message }}
                </div>
                <div v-if='is_loading' class='loading-container'>
                    <Loading />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import NumberFlow from '@number-flow/vue'
import LockItInPrice from '@/ecom/components/header/lock_it_in/LockItInPrice.vue';
import Button from '@/ecom/components/buttons/Button.vue';
import Loading from '@/ecom/components/loading/Loading.vue';
import Toast from '@/ecom/components/popups/Toast.vue';

export default {
    components: { NumberFlow, LockItInPrice, Button, Loading, Toast},
    props: ['total_allowed_bottles', 'current_bottles', 'lock_it_in_data', 'cart_totals', 'loading', 'is_amend'],
    data() {
        return {
            quantity: 0,
            price: 0.00,
            frequency_text: '',
            error_message: '',
            is_loading: false,
            alert_queue: [],
        }
    },
    methods: {
        checkout() {
            this.error_message = '';
            if (this.cart_totals.total_quantity == 12 ||
                this.cart_totals.total_quantity == 24 ||
                this.cart_totals.total_quantity == 36 ||
                this.cart_totals.total_quantity == 48) {
                this.$router.push('/lock-it-in/checkout');
            } else {
                this.error_message = `Please select 12, 24, 36 or 48 bottles to proceed to checkout`;
            }
        },
        save() {
            this.error_message = '';
            if (this.cart_totals.total_quantity == 12 ||
                this.cart_totals.total_quantity == 24 ||
                this.cart_totals.total_quantity == 36 ||
                this.cart_totals.total_quantity == 48) {
                this.amendSelection();
            } else {
                this.error_message = `Please select 12, 24, 36 or 48 bottles to amend selection`;
            }
        },
        async amendSelection() {
            this.is_loading = true;
            let response = await fetch(`/api/lock-it-in/amend-selection`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({}),    
            });

            let results = await checkAuth(response);
            if (response.status === 200){
                if(results.trs_error_message == ''){
                    this.$router.push('/lock-it-in/members');
                }
                else{
                    this.alert_queue.push({type : 'error', text: results.trs_error_message});
                }
            }
            this.is_loading = false;
        },
        setQuantity(){

            if(this.lock_it_in_data.from_landing_page){
                return;
            }

            if (this.cart_totals.total_quantity <= 12) {
                    this.lock_it_in_data.quantity = 12;
                } else if (this.cart_totals.total_quantity > 12 && this.cart_totals.total_quantity <= 24) {
                    this.lock_it_in_data.quantity = 24;
                } else if (this.cart_totals.total_quantity > 24 && this.cart_totals.total_quantity <= 36) {
                    this.lock_it_in_data.quantity = 36;
                } else if (this.cart_totals.total_quantity > 36) {
                    this.lock_it_in_data.quantity = 48;
                }

                // If quantity is 0 or undefined, set it to 12
                if (this.lock_it_in_data.quantity == 0 || typeof this.lock_it_in_data.quantity === 'undefined') {
                    this.lock_it_in_data.quantity = 12;
            }
        }
    },
    watch: {
        'lock_it_in_data': function () {
            this.error_message = '';
            switch (this.lock_it_in_data.frequency) {
                case 2:
                    this.frequency_text = '2 months'
                    break;
                case 3:
                    this.frequency_text = '3 months'
                    break;
                default:
                    this.frequency_text = 'monthly'
                    break;
            }
        },
        'cart_totals': {
            handler() {
                this.setQuantity();
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.lock-it-in-summary-container {
    display: flex;
    justify-content: center;
    position: sticky;
    top: 12px;
    z-index: 1;

    @media(max-width: 768px){
        top: 0px;
    }
}

.locked-in-text {
    font-size: 1.3rem;
    gap: 100px;
    border: 1px solid hsl(from var(--maj-slate) h s l / 0.5);
    border-radius: 8px;
    padding: 24px 48px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1000px;
    align-items: center;
    background-color: white;

    @media(max-width: 768px){
        flex-direction: column;
        gap: 12px;
        font-size: 1.1rem;
    }
}

.loading-container {
    width: 40px;
    height: 40px;
    margin: auto;
}

.checkout-button {
    width: 200px;

    @media(max-width: 768px){
        width: 160px;
    }
}

.error-message {
    color: #e03131;
    font-size: 0.85rem;
}

.checkout-button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}
</style>